import {
  $convertFromMarkdownString,
  $convertToMarkdownString,
  TRANSFORMERS,
} from '@lexical/markdown'

export function readMarkdownFromEditor(editor) {
  return new Promise(resolve => {
    editor.read(() => {
      resolve($convertToMarkdownString(TRANSFORMERS))
    })
  })
}

export function writeMarkdownToEditor(editor, markdownContent) {
  return new Promise(resolve => {
    editor.update(() => {
      $convertFromMarkdownString(markdownContent, TRANSFORMERS)
      resolve()
    })
  })
}
